class ApexProductDialog {
  constructor({ handle, salePrice, tag, viewMore, viewLess, buttonAdd }) {
    /** 商品标识 */
    this.handle = handle;
    /** 销售价格 */
    this.salePrice = salePrice;
    /** 商品标签 */
    this.tag = tag;
    /** 查看更多 */
    this.t_viewMore = viewMore;
    /** 查看更少 */
    this.t_viewLess = viewLess;
    /** 添加到购物车 */
    this.t_buttonAdd = buttonAdd;
    /** 当前选中的变体 */
    this.currentVariant = null;
    /** 当前选中的选项 */
    this.currentOptions = [];
    /** 商品数据 */
    this.product = null;
    /** context */
    this.context = null;
    this.showProductDialog();
    this.bindMaskEvent();
    this.queryProduct().then(() => {
      if (!this.context) return;
      this.getFirstAvailableVariant();
      this.createDialogHTML();
      this.bindOptionEvent();
      this.bindViewDescEvent();
      this.initApexSwiper();
    });
  }

  /** 创建空白弹窗 */
  showProductDialog = () => {
    const dialog = document.createElement("div");
    dialog.classList.add("apex-product-dialog");
    const __HTML = `
      <div class="apex-product-dialog__mask"></div>
      <div class="apex-product-dialog__container">
        <div class="apex-product-dialog__content">
          <div class="apex-product-dialog__body">
            <div class="loading">
              <div class="loading__spinner"></div>
            </div>
          </div>
        </div>
      </div>
    `;
    dialog.innerHTML = __HTML;
    document.body.appendChild(dialog);
    this.context = dialog;
  };

  /** 根据productHandle查询商品的数据 */
  queryProduct = () =>
    new Promise((resolve, reject) => {
      fetch(`${Shopify.routes.root}products/${this.handle}.js`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`查询商品失败，状态码: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          this.product = data;
          resolve(data);
          return data; // 返回查询到的商品数据
        })
        .catch((error) => {
          reject();
        });
    });

  /** 获取第一个可用的变体 */
  getFirstAvailableVariant = () => {
    const variants = this.product.variants;
    if (variants.length === 0) {
      return null;
    }
    this.currentVariant = variants.find((item) => item.available);
    this.currentOptions = [...this.currentVariant.options];
  };

  /** 处理变量名，转小写，空格转下划线_ */
  handleVariantName = (name) => {
    return name.toLowerCase().replace(/\s+/g, "_");
  };

  /** 生成scrollSnap轮播图html */
  createScrollSnapHTML = () => {
    const medias = this.product.media;
    const __HTML = `
    <div class="apex-swiper">
      <div class="apex-swiper-wrapper">
        <div class="apex-swiper-scroll">
          ${medias.map((media) => `<div class="swiper-slide"><img src="${media.preview_image.src}" data-control="${media.position}"></div>`).join("")}
        </div>
      </div>
    </div>
    `;
    return __HTML;
  };

  /** 根据salePrice获取最终的售价和划线价 */
  getPrice = () => {
    const { price, compareAtPrice } = this.currentVariant;
    const thisPrice = this.salePrice ?? price;
    const delPrice = this.salePrice ? price : compareAtPrice;
    if (delPrice == thisPrice) {
      return "";
    }
    return [Apex.currencyFormatter().formatPrice(thisPrice), Apex.currencyFormatter().formatPrice(delPrice)];
  };

  /** 生成价格
   *- 如果有售价，则展示售价，划线原价
   *- 如果没有售价，则展示原价，划线有就展示没有就不展示
   */
  createPriceHTML = () => {
    const [price, compareAtPrice] = this.getPrice();
    const __HTML = `
    <div class="apex-product-dialog__price">
      <span class="apex-product-dialog__price-sale">${price}</span>
      ${compareAtPrice ? `<del class="apex-product-dialog__price-old">${compareAtPrice}</del>` : ""}
      ${this.tag ? `<span class="associalted-sale-tag mirror-effect">${this.tag}</span>` : ""}
    </div>
    `;
    return __HTML;
  };

  /** 循环渲染选项 */
  createOptionsHTML = () => {
    const { options, variants } = this.product;
    if (!options || options.length === 0 || variants.length === 1) {
      // 如果没有选项或者只有一个变体，则不渲染选项
      return "";
    }
    const currentOptions = this.currentVariant.options;
    const __HTML = `
      <div class="apex-product-dialog__option">
        <div class="apex-product-dialog__option-list">
          ${options
            .map(
              (option) => `
              <fieldset class="apex-product-dialog__option-section">
              <h3>${option.name}</h3>
              <div class="apex-product-dialog__option-section-row">
                ${option.values
                  .map(
                    (value) => `
                  <label 
                    data-name="${this.handleVariantName(option.name)}" 
                    class="apex-product-dialog__option-item ${currentOptions.includes(value) ? "active" : ""}"
                  >
                    <input 
                      type="radio" 
                      data-position="${option.position}" 
                      name="${this.handleVariantName(option.name)}" 
                      value="${value}" ${currentOptions.includes(value) ? "checked" : ""}
                    >
                    <span>${value}</span>
                  </label>
                  `
                  )
                  .join("")}
              </div>
              </fieldset>
              `
            )
            .join("")}
        </div>
      </div>
    `;
    return __HTML;
  };

  /** 创建添加到购物车按钮 */
  createAddToCartButton = () => {
    const buttonHTML = `
    <form
      method="post"
      action="/cart/add"
      id="associal_${this.product.id}"
      accept-charset="UTF-8"
      enctype="multipart/form-data"
      is="product-form"
      class="apex-product-dialog__add-form"
    >
      <input type="hidden" name="form_type" value="product">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="product-id" value="${this.product.id}">
      <input type="hidden" name="id" value="${this.product.variants[0].id}">
      <div class="v-stack gap-4">
        <buy-buttons form="associal_${this.product.id}">
          <button type="submit" class="apex-product-dialog__submit" is="custom-button">
            <div>${this.t_buttonAdd}</div>
          </button>
        </buy-buttons>
      </div>
    </form>
    `;
    return buttonHTML;
  };

  /** 获取变体商品链接 */
  getVariantLink = () => {
    const product = this.product;
    const variant = this.currentVariant;
    const linkUrl = `${Shopify.routes.root}products/${product.handle}?variant=${variant.id}`;
    return linkUrl;
  };

  /** 根据product生成弹窗dom结构并展示到页面上 */
  createDialogHTML = () => {
    const product = this.product;
    const dialogBody = this.context.querySelector(".apex-product-dialog__body");
    const __HTML = `
      ${this.createScrollSnapHTML()}
      <a class="apex-product-dialog__title" href="${this.getVariantLink()}">${product.title}</a>
      ${this.createPriceHTML()}
      ${this.createOptionsHTML()}
      ${this.createAddToCartButton()}
      <div class="apex-product-dialog__desc">${product.description}</div>
      <button class="apex-product-dialog__view-desc">
        <span class="more">${this.t_viewMore}</span>
        <span class="less">${this.t_viewLess}</span>
        <span class="animated-arrow"></span>
      </button>
    `;
    dialogBody.innerHTML = __HTML;
  };

  /** 为option绑定事件，值修改后触发 */
  bindOptionEvent = () => {
    const options = this.product.options;
    if (!options || options.length === 0) {
      return;
    }
    options.forEach((option) => {
      const { variants } = this.product;
      const optionElement = this.context.querySelectorAll(`[name="${this.handleVariantName(option.name)}"]`);
      optionElement.forEach((element) => {
        element.addEventListener("change", (event) => {
          const el = event.target;
          const value = el.value;
          const position = el.dataset.position;
          const newOptions = [...this.currentVariant.options];
          newOptions[Number(position) - 1] = value;
          const selectedVariant = variants.find((variant) => {
            return variant.options.every((option, index) => {
              return option === newOptions[index];
            });
          });
          if (selectedVariant) {
            if (this.swiper) {
              const imgPosition = selectedVariant.featured_media.position;
              if (imgPosition) {
                this.swiper.scrollToIndex(Number(imgPosition) - 1);
              }
            }
            this.currentVariant = selectedVariant;
            this.currentOptions = selectedVariant.options;
            this.updatePrice();
            const prevActiveElement = this.context.querySelector(`[data-name="${el.name}"].active`);
            prevActiveElement.classList.remove("active");
            el.parentNode.classList.add("active");
          }
        });
      });
    });
  };

  /** 更新价格dom中的数值以及form中input[name="id"]的值和标题的链接 */
  updatePrice = () => {
    const [price, compareAtPrice] = this.getPrice();
    const priceElement = this.context.querySelector(".apex-product-dialog__price-sale");
    const delPriceElement = this.context.querySelector(".apex-product-dialog__price-old");
    const variantIdElement = this.context.querySelector(".apex-product-dialog__add-form input[name='id']");
    const titleElement = this.context.querySelector(".apex-product-dialog__title");
    titleElement.href = this.getVariantLink();
    priceElement.textContent = price;
    variantIdElement.value = this.currentVariant.id;
    if (delPriceElement && compareAtPrice) {
      delPriceElement.textContent = compareAtPrice;
    }
  };

  /** 给view-desc绑定点击事件，获取desc的高度以动画形式展开/收起 */
  bindViewDescEvent = () => {
    const viewDescElement = this.context.querySelector(".apex-product-dialog__view-desc");
    viewDescElement.addEventListener("click", () => {
      const descElement = this.context.querySelector(".apex-product-dialog__desc");
      viewDescElement.classList.toggle("active");
      if (viewDescElement.classList.contains("active")) {
        descElement.style.height = `${descElement.scrollHeight}px`;
        setTimeout(() => {
          descElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 300);
      } else {
        descElement.style.height = "0";
      }
    });
  };

  /** 给mask绑定点击事件，关闭弹窗和mask */
  bindMaskEvent = () => {
    const maskElement = this.context.querySelector(".apex-product-dialog__mask");
    maskElement.addEventListener("click", () => {
      document.body.removeChild(this.context);
      this.context = null;
    });
  };

  /** 初始化ApexSwiper */
  initApexSwiper = () => {
    const swiperElement = this.context.querySelector(".apex-swiper");
    if (swiperElement) {
      this.swiper = new ApexSwiper(swiperElement);
    }
  };
}

window.ApexProductDialog = ApexProductDialog;
